import React from 'react'

const NotFoundComponent = () => <div style={{ color: 'red' }}>404</div>

export default NotFoundComponent
